import React, { Fragment } from "react";

const ProcessContent = [
  {
    num: "1",
    title: "Frame the Problem",
    desc: `It is an important part as we must regularly solve complex problems in difficult circumstances..`,
    fadeUp: "fade-up",
    dataDelay: "",
  },
  {
    num: "2",
    title: "Collect the Data",
    desc: `It allows you to store and analyze important information about your existing and potential customers..`,
    fadeUp: "fade-up",
    dataDelay: "150",
  },
  {
    num: "3",
    title: "Process the Data",
    desc: `It creates better business strategies and increase their competitive edge`,
    fadeUp: "fade-up",
    dataDelay: "300",
  },
];

const FancyFeatureThree = () => {
  return (
    <Fragment>
      <div className="row justify-content-center gx-xxl-5">
        {ProcessContent.map((val, i) => (
          <div
            key={i}
            className="col-lg-4 col-sm-6 d-flex"
            data-aos={val.fadeUp}
            data-aos-delay={val.dataDelay}
          >
            <div className="block-style-three mb-25">
              <div className="numb">{val.num}</div>
              <h6>{val.title}</h6>
              <p>{val.desc}</p>
            </div>
            {/* /.block-style-three */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default FancyFeatureThree;
